import React from 'react';
import { MenuItem, TextField } from '@material-ui/core';
import { Control, Controller } from 'react-hook-form';
import { DiamDetailsFields, DiamDetailsTextField } from '../DiamDetailsFields';
import { SectionTitle } from '../IdentityDetails/styles';
import { FieldStack } from './styles';
import { RoleDetailsFormValues, RoleModifierField } from './types';

interface RoleDetailsModifiersSectionProps {
  isEditing: boolean;
  control: Control<RoleDetailsFormValues>;
  modifiers: RoleModifierField[];
}

export function RoleDetailsModifiersSection({
  isEditing,
  control,
  modifiers,
}: RoleDetailsModifiersSectionProps) {
  return (
    <>
      <SectionTitle color="textPrimary" variant="h6">
        Modifiers
      </SectionTitle>
      {isEditing ? (
        <FieldStack>
          {modifiers.map((modifierField, index) => (
            <Controller
              key={modifierField.id}
              name={`modifiers.${index}.value`}
              control={control}
              render={({ field, fieldState: { error } }) => {
                if (modifierField.inputType === 'select') {
                  return (
                    <TextField
                      {...field}
                      select
                      variant="outlined"
                      label={modifierField.label}
                      required
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      error={Boolean(error)}
                      helperText={error?.message}
                    >
                      {modifierField.options.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  );
                }

                return (
                  <TextField
                    {...field}
                    variant="outlined"
                    label={modifierField.label}
                    required
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    error={Boolean(error)}
                    helperText={error?.message}
                  />
                );
              }}
            />
          ))}
        </FieldStack>
      ) : (
        <DiamDetailsFields>
          {modifiers.map(modifierField => (
            <DiamDetailsTextField
              key={modifierField.id}
              title={modifierField.label}
              value={modifierField.value}
            />
          ))}
        </DiamDetailsFields>
      )}
    </>
  );
}
